/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Thêm"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Xóa tất cả"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var viVN = Object.assign(TranslationProviderComponent, {
  translations
});

export { viVN as v };
//# sourceMappingURL=vi-VN-CzuQrWbf.js.map
